<template>
    <div>
        <b-row>
            <b-col class="d-flex justify-content-between align-items-center">
                <text-header id="atmo-contract-fulfillment" class="atmo-hash-jump-point">Исполнение контракта</text-header>
            </b-col>
        </b-row>
        <template v-if="purchase.is_customer">
            <form-row-single-select v-model="form.status" :options="dictionaries.purchaseStatuses" label-field="title" label="Изменить статус закупки" :content-cols-lg="8" :content-cols-sm="9">
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button
                        variant="custom-green"
                        @click="changeStatus"
                        class="text-uppercase ml-3"
                        :disabled="form.status === purchase.status.id || $v.form.$invalid">
                        Изменить статус
                    </b-button>
                </b-overlay>
            </form-row-single-select>
            <form-row-upload-multiple-documents v-model="executionDocuments" :is-loading="isWaiting" :v="$v.executionDocuments" header-class="fs-14 fix-pos" title="Документы об исполнении" @add="onAddFile" @remove="onRemoveFile" compact with-number/>
        </template>
        <template v-else>
            <text-row label="Статус закупки" v-model="purchase.status.title" compact />
            <text-row-documents v-if="purchase.is_supplier" v-model="executionDocuments" label="Документы об исполнении" compact />
        </template>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import FormRowUploadMultipleDocuments from '@/components/common/form-rows/form-row-upload-multiple-documents.vue';

export default {
    name: 'fl44-unknown-volume-contract-fulfillment-block',
    components: { FormRowUploadMultipleDocuments },
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    async mounted() {
        await this.fillData();
    },
    data() {
        return {
            isWaiting: false,
            isDataSending: false,
            form: {
                status: null
            },
            dictionaries: {
                purchaseStatuses: []
            }
        }
    },
    validations() {
        return {
            executionDocuments: {},
            form: {
                status: { required }
            }
        }
    },
    methods: {
        async fillData() {
            this.dictionaries.purchaseStatuses = this.$globalDictionaries.purchaseStatuses.filter((item) => item.stage === 'contract' && item.id !== 'contract:failed');
            this.form.status = this.purchase.status.id;
        },
        async onAddFile(file) {
            this.isWaiting = true;
            try {
                const response = await this.$api.personal.fl44UnknownVolume.storeExecutionDocument(this.purchase.id, file);
                if (response) {
                    this.$emit('refresh', null);
                }
            } finally {
                this.isWaiting = false;
            }
        },
        async onRemoveFile(file) {
            this.isWaiting = true;
            try {
                const response = await this.$api.personal.fl44UnknownVolume.deleteExecutionDocument(this.purchase.id, file.document_id);
                if (response) {
                    this.$emit('refresh', null);
                }
            } finally {
                this.isWaiting = false;
                await this.refresh();
            }
        },
        async changeStatus() {
            this.isDataSending = true;
            try {
                const response = await this.$api.personal.fl44UnknownVolume.changeStatus(this.purchase.id, this.form);
                if (response) {
                    this.$emit('refresh', null);
                }
            } finally {
                this.isDataSending = false;
            }
        }
    },
    computed: {
        executionDocuments: {
            get() {
                return this.purchase?.execution_documents;
            }
        }
    }
};
</script>
